export const RESET_HOME_PAGE_STATE_QUERY_PARAM = 'resetHomePageState' as const;
export const RESET_HOME_PAGE_STATE_QUERY_VALUE = 'true' as const;

export function shouldResetHomePageState(queryParamValue: string | string[] | undefined) {
  if (Array.isArray(queryParamValue)) {
    return queryParamValue.includes(RESET_HOME_PAGE_STATE_QUERY_VALUE);
  }

  return queryParamValue === RESET_HOME_PAGE_STATE_QUERY_VALUE;
}
